/* eslint-disable no-console */
import {useQuery} from '@tanstack/react-query';
import {ProvidersMedicalGuide} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {FeaturesEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';
import {useAccountInformation, useQueryParams} from 'presentation/pages/private';
import {getHealthProviders} from '../../services/getHealthProviders';
import {UseHealthProvidersQueryParams} from './types';

export function useHealthProvidersQuery({
	cdUf,
	nmCidade,
	dsEspecialidade,
	dsTipo,
	tpRede,
	coordenadas,
	distancia,
}: UseHealthProvidersQueryParams) {
	const {SEARCH_PARAMS} = useQueryParams();
	const {step, networkCode, cd_procedimento} = SEARCH_PARAMS;
	const {isEnabled: providersV3IsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_MOD_GUIDE_FLOW_MEDICAL_GUIDE_GET_PROVIDERS_V3,
	);
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();

	const {accesses} = useAccountInformation();

	const userSelectedTpRede = !!(networkCode !== undefined && networkCode !== '');

	const isPpo = accesses?.ppoProduct ?? false;

	return useQuery<ProvidersMedicalGuide[]>({
		queryKey: [
			QUERY_KEYS.HEALTH_PROVIDERS_GUIDE,
			{
				cdUf,
				nmCidade,
				dsTipo,
				dsEspecialidade,
				cd_procedimento,
				tpRede,
				isPpo,
				userSelectedTpRede,
				isGndiSaoPaulo,
				coordenadas,
				distancia,
				isNotredameSaude,
			},
		],
		queryFn: async ({signal}) => {
			if (isPpo && !userSelectedTpRede) {
				console.error('É necessário selecionar uma rede para planos PPO');
			}

			if (!coordenadas || (!cdUf && !nmCidade)) {
				console.error('É necessário selecionar uma localização válida');
			}

			const tpRedeFinal = isPpo ? tpRede : 0;

			return getHealthProviders({
				...(coordenadas === undefined && {cdUf}),
				...(coordenadas === undefined && {nmCidade}),
				...(coordenadas !== undefined && {coordenadas}),
				dsTipo,
				dsEspecialidade,
				cd_procedimento,
				retornoAgrupado: isGndiSaoPaulo,
				tpRede: isGndiSaoPaulo || isNotredameSaude ? tpRedeFinal : undefined,
				distancia,
				signal,
			});
		},
		enabled: providersV3IsEnabled
			? false
			: Boolean((cdUf && nmCidade) || coordenadas) && Boolean(step === GuideStep.RESULTS),
	});
}
